import { Route, Routes } from "react-router";
import Accounts from "../Pages/Accounts";
import Candidates from "../Pages/Candidates";
import CandidateDetails from "../Pages/CandidateDetails";
import ForgotPassword from "../Pages/ForgotPassword/Index";
import Home from "../Pages/Home";
import InterviewSettings from "../Pages/InterviewSettings";
import GoogleCalendarAuth from "../Pages/InterviewSettings/components/GoogleCalendarAuth";
import JobPostDetails from "../Pages/JobPostDetails";
import JobPosts from "../Pages/JobPosts";
import AddJobPost from "../Pages/AddJobPostV3";
import NotFound from "../Pages/NotFound/Index";
import OrganizationSettings from "../Pages/OrganizationSettings";
import ResetPassword from "../Pages/ResetPassword/Index";
import SignIn from "../Pages/SignIn";
import SignUp from "../Pages/SignUp";
import TeamMemberSignUp from "../Pages/SignUp/TeamMemberSignUp";
import TeamMembers from "../Pages/TeamMembers";
import ProtectedRoute from "./ProtectedRoute";
import PreLoad from "../Pages/PreLoad";
import Dashboard from "../Pages/Dashboard";
import EnterprisePlanContact from "../Pages/EnterprisePlanContact";
import ZohoAuthCallBack from "../Pages/AuthCallBack/ZohoAuthCallBack";
import LeverAuthCallBack from "../Pages/AuthCallBack/LeverAuthCallBack";
import Resources from "../Pages/Resources";
import ApplicationDetailsPage from "../Pages/ApplicationDetails";
import ZohoRecruitProcess from "../Pages/ZohoRecruitProcess";
import ApiDocs from "../Pages/ApiDocs/ApiDocs";
import ReleaseNotesDetail from "../Pages/ReleaseNotesDetail";
import TransactionDetails from "../Pages/TransactionDetails/TransactionDetails";
import CreditPurchase from "../Pages/CreditPurchase";
import Pricing from "../Pages/Pricing";
import PlanPurchase from "../Pages/PlanPurchase";
import ProfileScreeningPage from "../Pages/ProfileScreening/ProfileScreeningPage";
import ScreeningProcessingPage from "../Pages/ProfileScreening/ScreeningProcessingPage";
import UserOnboarding from "../Pages/PreLoad/UserOnboarding";
import UserNotSignedInRoute from "./UserNotSignedInRoute";
const Routing = () => {
  return (
    <Routes>
      <Route path="/sign-in" element={<SignIn />} />
      <Route path="/sign-up" element={<SignUp />} />
      <Route path="/auth/member/sign-up" element={<TeamMemberSignUp />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route
        path="/profile-screening"
        element={
          <UserNotSignedInRoute>
            <ProfileScreeningPage />
          </UserNotSignedInRoute>
        }
      />
      <Route path="*" element={<NotFound />} />
      <Route path="/404" element={<NotFound />} />
      <Route
        path="application-details"
        element={
          <ProtectedRoute>
            <ApplicationDetailsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pre-load"
        element={
          <ProtectedRoute>
            <PreLoad />
          </ProtectedRoute>
        }
      />
      <Route
        path="/screening-processing"
        element={
          <ProtectedRoute>
            <ScreeningProcessingPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/user-onboarding"
        element={
          <ProtectedRoute>
            <UserOnboarding />
          </ProtectedRoute>
        }
      />
      <Route path="" element={<Dashboard />}>
        <Route
          index
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/job-posts"
          element={
            <ProtectedRoute>
              <JobPosts />
            </ProtectedRoute>
          }
        />

        <Route
          path="/job-posts/:jobPostId"
          element={
            <ProtectedRoute>
              <JobPostDetails />
            </ProtectedRoute>
          }
        />

        <Route
          path="/add-job-post"
          element={
            <ProtectedRoute>
              <AddJobPost />
            </ProtectedRoute>
          }
        ></Route>

        <Route
          path="/candidates"
          element={
            <ProtectedRoute>
              <Candidates />
            </ProtectedRoute>
          }
        />

        <Route
          path="/candidate/:candidateId"
          element={
            <ProtectedRoute>
              <CandidateDetails />
            </ProtectedRoute>
          }
        />

        <Route
          path="/team-members"
          element={
            <ProtectedRoute>
              <TeamMembers />
            </ProtectedRoute>
          }
        ></Route>
        <Route
          path="/organization"
          element={
            <ProtectedRoute>
              <OrganizationSettings />
            </ProtectedRoute>
          }
        ></Route>
        <Route
          path="/interview-settings"
          element={
            <ProtectedRoute>
              <InterviewSettings />
            </ProtectedRoute>
          }
        ></Route>
        <Route path="/calendar-auth" element={<GoogleCalendarAuth />}></Route>
        <Route
          path="/accounts"
          element={
            <ProtectedRoute>
              <Accounts />
            </ProtectedRoute>
          }
        />
        <Route
          path="/resources"
          element={
            <ProtectedRoute>
              <Resources />
            </ProtectedRoute>
          }
        />
        <Route
          path="/release-notes/:version"
          element={
            <ProtectedRoute>
              <ReleaseNotesDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/pricing"
          element={
            <ProtectedRoute>
              <Pricing />
            </ProtectedRoute>
          }
        ></Route>
        <Route
          path="/enterprise-plan"
          element={
            <ProtectedRoute>
              <EnterprisePlanContact />
            </ProtectedRoute>
          }
        />
        <Route
          path="/transaction-details"
          element={
            <ProtectedRoute>
              <TransactionDetails />
            </ProtectedRoute>
          }
        ></Route>
        <Route
          path="/plan-purchase"
          element={
            <ProtectedRoute>
              <PlanPurchase />
            </ProtectedRoute>
          }
        />
        <Route
          path="/credit-purchase"
          element={
            <ProtectedRoute>
              <CreditPurchase />
            </ProtectedRoute>
          }
        />
        <Route path="/zoho/oauth/callback" element={<ZohoAuthCallBack />} />
        <Route path="/lever/callback" element={<LeverAuthCallBack />} />
        <Route path="/zoho/candidate/apply" element={<ZohoRecruitProcess />} />
      </Route>

      <Route
        path="/api-docs"
        element={
          <ProtectedRoute>
            <ApiDocs />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default Routing;
